import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { RMS_ALARM_ID_FETCH_SUCCESS } from "../../Reducer/rmsAlarmIdSlice";
import Agent from "../../Network/Agent";
import CountdownTimer from "../../Props/CountdownTimer";
import { RMS_ACTIVE_HISTORY_FETCH_START } from "../../Reducer/RmsActiveAlarmHistorySlice";
import API, { cancelAllRequests, createController } from "../../Network/API";
import AcknowledgmentModel from "../../Models/AcknowledgmentModel";
import AlarmAcknowledgmentViewModal from "../../Models/AlarmAcknowledgmentViewModal";
import isTenantUser from "../../CustomHook/tenantUser";

export default function RmsActiveAlarm() {
  const ddd = useParams();
  const dispatch = useDispatch()
  const [page, setPage] = useState(1);
  const selector_rms_alarm_nav = useSelector((state) => state.rmsAlarmGroupReducer)
  const rmsActiveAlarm = useSelector((state) => state.rmsActiveAlarmHistoryReducer)
  const tenants = useSelector((state) => state.tenantReducer)
  const { user: profileUser } = useSelector((state) => state.profileReducer);
  const { user: authUser } = useSelector((state) => state.authReducer);
  const tenantUser = isTenantUser(profileUser?.id ? profileUser : authUser);
  const [site_id, setSiteId] = useState('');
  const [tenant_id, setTenantId] = useState('');
  const [loading_export, setLoadingExport] = useState(false);
  const [searchParam, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const controllerRef = useRef(null);
  const [isAckModalOpen, setIsAckModalOpen] = useState(false);
  const [selectedAlarm, setSelectedAlarm] = useState(null);
  const [actionMode, setActionMode] = useState("ack");
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [viewAlarm, setViewAlarm] = useState(null);
  const array_data = {
    'site_id': '',
    'alarm_type': ddd.id,
    'tenant_id': '',
    'page': page,
    'loadMore': false,
  }

  const handleClick = (link) => {
    if (link) {
      navigate(link);
    }
  };

  const toggleAckModal = () => {
    setIsAckModalOpen((prev) => !prev);
  };

  const openActionModal = (alarm, mode) => {
    setSelectedAlarm(alarm);
    setActionMode(mode);
    setIsAckModalOpen(true);
  };

  const openViewModal = (alarm) => {
    setViewAlarm(alarm);
    setIsViewModalOpen(true);
  };

  const stopRowClick = (event) => {
    event.stopPropagation();
  };

  const fetchActiveAlarms = (signal) => {
    if (page != 1) {
      array_data.loadMore = true;
      Agent.RMS_ALARM.rms_fetch_alarm_load_more(dispatch, array_data, signal);
      return;
    }

    dispatch(RMS_ALARM_ID_FETCH_SUCCESS(ddd.id));
    dispatch(RMS_ACTIVE_HISTORY_FETCH_START());
    Agent.RMS_ALARM.rms_fetch_alarm(dispatch, array_data, signal);
  };


  const copyToClipboard = (s_data) => {
    // Manually construct the text with line breaks between fields
    const formattedText = `
          Site ID: ${s_data.site_id}
          Operator Site ID: ${s_data.easi_site_id}
          Tenant: ${s_data.tenant_name}
          Alarm Name: ${s_data.name}
          Alarm Time: ${s_data.alarm_start}
        `;

    // Create a temporary textarea element to copy the formatted text
    const textArea = document.createElement('textarea');
    textArea.value = formattedText;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);

    alert('Copied to clipboard!');
  };

  const handleExport = async (e) => {
    setLoadingExport(true);
    try {
      const response = await API.get(`/v1/oauth/report/export_active_alarm?tenant=${tenant_id}&type=${ddd.id}&site_id=${site_id}`, {
        responseType: 'blob',
      });

      // Extract filename from Content-Disposition header or set a default
      const contentDisposition = response.headers['content-disposition'];
      let filename = 'rms_active_alarms.xlsx'; // Default filename

      if (contentDisposition) {
        const matches = /filename[^;=\n]*=(['"]?)([^'";\n]*)\1/.exec(contentDisposition);
        if (matches && matches[2]) {
          filename = matches[2];
        }
      }

      // Create download link and trigger download
      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(new Blob([response.data]));
      downloadLink.download = filename;
      document.body.appendChild(downloadLink);
      downloadLink.click();

      // Clean up the download link to avoid memory leaks
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(downloadLink.href);
    } catch (error) {
      console.error('Error exporting file:', error);
    } finally {
      setLoadingExport(false);
    }
  };

  const handleBrandChange = (e) => {
    const value = e.target.value;
    setTenantId(value);
    // Remove brand from search params if manually selected
    if (searchParam.has("tenant_id")) {
      setSearchParams({});
    }
  };

  useEffect(() => {

      cancelAllRequests();
    const controller = createController();
    const signal = controller.signal;

    document.title = "iMac | RMS Active Alarm"
    if (tenant_id != '') {
      array_data.tenant_id = tenant_id;
    } else {
      if (searchParam.get("tenant_id")) {
        array_data.tenant_id = searchParam.get("tenant_id");
      }

    }
  

    array_data.site_id = site_id;
    array_data.alarm_type = ddd.id;
    array_data.page = page;
    Agent.RMS_ALARM.nav(dispatch, signal);
    fetchActiveAlarms(signal)
    // return () => {
    //   controller.abort();
    // };

  }, [ddd.id, page, site_id, tenant_id]);


  useEffect(() => {
    setPage(1)
    
  }, [ddd.id]);

  const searchSite = (q) => {
    setPage(1)
    setSiteId(q);
  }

  const searchTenant = (q) => {
    setPage(1)
    setTenantId(q);
  }


  const observer = useRef();
  const lastElementRef = useCallback((element) => {
    //element is the react element being referenced

    // disconnect observer set on previous last element
    if (observer.current) observer.current.disconnect();

    // if there's no more data to be fetched, don't set new observer
    if (!rmsActiveAlarm?.data.has_more_page) return;

    // set new observer
    observer.current = new IntersectionObserver((entries) => {
      // increase page number when element enters (is intersecting with) viewport.
      // This triggers the pagination hook to fetch more items in the new page
      if (entries[0].isIntersecting && rmsActiveAlarm?.data.has_more_page) setPage((prev) => prev + 1);
    });

    // observe/monitor last element
    if (element) observer.current.observe(element);
  }, [rmsActiveAlarm?.data.has_more_page]);
  return (
    <>
      <div className="row g-2 mt-2 mb-2">
        <div className="col-md-3 p-3">
          <div className="scroll-side-rms">

            <table className="table table-borderless bg-white p-2 rounded">
              {!selector_rms_alarm_nav?.loading && selector_rms_alarm_nav?.data?.rms_alarm_group?.map((rms_alarm, index) => (
                <>
                  <tr className="bg-dark text-white">
                    <th className="p-2" colSpan={2}>{rms_alarm.name}</th>
                  </tr>
                  {rms_alarm?.alarm?.map((alarm, iendex) => (
                    <tr >
                      <td onClick={() => handleClick(`/rms_alarm_filter/${alarm.order_list}/fatch`)} style={{ borderBottom: '0.5px solid #000', fontSize: '14px' }} className="p-1 clickable">
                        <label className="form-check-label " htmlFor={`flexCheckDefaultRms${alarm.id}`}>
                          {alarm.name}
                        </label>
                      </td>
                      <td style={{ borderBottom: '0.5px solid #000', fontSize: '14px' }}>
                        <span style={{ padding: '8px' }} className={`badge ${alarm.active_alarm_count > 0 ? 'badge-secondary-red' : 'badge-secondary'} rounded-pill`}>{alarm.active_alarm_count}</span>
                      </td>
                    </tr>
                  ))}

                </>
              ))}
            </table>

          </div>
        </div>
        <div className="col-md-9">

          {/* // title and filter tenant and site with export */}
          <div className="row g-2 mb-2">

            <div className="col-md-8">
              <h6 className="m-0 p-0">Total Alarms: {rmsActiveAlarm?.data?.total_page}</h6>
              <p className="p-0 m-0 fs-12">Current Display 1 - {rmsActiveAlarm?.alarms?.length} Record(s), {rmsActiveAlarm?.data?.total_page} Record(s) Totally</p>

            </div>
            <div className="col-md-4 text-end ">

              <div className="input-group input-group-sm">
                <input type="text" onKeyUp={(e) => searchSite(e.target.value)} className="form-control form-control-sm" placeholder="Search by site id...." aria-label="Search" aria-describedby="basic-addon1" />
                {!tenantUser && (
                <select onChange={(e) => handleBrandChange(e)} className="form-select form-select-sm" aria-label=".form-select-sm example">
                  <option value="">All Tenants</option>
                  {tenants?.data?.length > 0 && tenants?.data?.map((tenant, indexI) => (
                    <option value={tenant.id}>{tenant.name}</option>
                  ))}

                </select>
                )}
                <a href="#" onClick={(e) => handleExport(e)} class="input-group-text btn btn-sm btn-info" id="basic-addon2"> <i className="fa-light fa-file-excel"></i> Export {loading_export ? (
                  <span
                    className="spinner-border spinner-border-sm ms-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                ) : (
                  <span></span>
                )}</a>
              </div>


            </div>
          </div>




          <div className="table-responsive custom-table-responsive scroll-side-rms-active ">
            <table className="table custom-table text-center ">
              <tbody>
                <>
                  {rmsActiveAlarm?.main_loading ? <p>Loading......</p> : ''}
                </>

                {!rmsActiveAlarm?.main_loading && rmsActiveAlarm?.alarms?.map((alarm, index) => (

                  <>
                    <tr
                      className="bg-white clickable"
                      style={{ cursor: "pointer" }}
                      onClick={() => openViewModal(alarm)}
                      ref={index === rmsActiveAlarm?.alarms.length - 1 ? lastElementRef : undefined}
                    >
                      <td>
                        <i
                          onClick={(e) => {
                            stopRowClick(e);
                            copyToClipboard(alarm);
                          }}
                          className="fa fa-copy text-success"
                          style={{ fontSize: '20px', cursor: 'pointer' }}
                        />

                      </td>
                      <td width="7%">
                        <div className="signal-bars mt1 sizing-box good four-bars">
                          <span>
                            <img src="/assets/icon/6.svg" className="tower-height" alt="" />
                          </span>
                          <div className={`first-bar bar ${alarm.network >= 1 ? '' : 'null-color'}`}>
                          </div>
                          <div className={`second-bar bar ${alarm.network >= 2 ? '' : 'null-color'}`}>
                          </div>
                          <div className={`third-bar bar ${alarm.network >= 3 ? '' : 'null-color'}`}>
                          </div>
                          <div className={`fourth-bar bar ${alarm.network >= 4 ? '' : 'null-color'}`}>
                          </div>
                          <div className={`fifth-bar bar ${alarm.network >= 5 ? '' : 'null-color'}`}>
                          </div>
                        </div>
                      </td>
                      <td width="6%" className="status" rel={alarm.id} data-value={alarm.site_id}>
                        <p className="tr-header">SITE ID</p>
                        <p className="tr-header-sub fw-bold">
                          <Link to={`/site/${alarm.site_id}`} onClick={stopRowClick}>{alarm.site_id}</Link>
                        </p>
                      </td>
                      <td width="12%">
                        <p className="tr-header">Tenant</p>
                        <p className="tr-header-sub ">{alarm.tenant_name}</p>
                      </td>
                      <td width="10%" >
                        <p className="tr-header">Operator Site</p>
                        <p className="tr-header-sub fw-bold">
                          <Link to={`/site/${alarm.site_id}`} onClick={stopRowClick}>{alarm.easi_site_id}</Link>
                        </p>
                      </td>
                      <td width="25%">
                        <p className="tr-header">Alarm Name</p>
                        <p className="tr-header-sub">
                          {alarm.name}
                        </p>
                      </td>
                      <td width="15%">
                        <p className="tr-header">Alarm Time</p>
                        <p className="tr-header-date">
                          {alarm.alarm_start}

                        </p>
                      </td>

                      <td width="20%" className="elisp_time">
                        <p className="tr-header">Elapsed Time</p>
                        <p className="tr-header-sub elisp_time">
                          {alarm.alarm_end != null ?
                            <span className="elisp_time">{alarm.total_elaspsed}</span>
                            :
                            <CountdownTimer targetDate={alarm.start} />
                          }


                        </p>
                      </td>
                      {!tenantUser && (
                      <td width="15%">
                        <p className="tr-header">Action</p>
                        <div className="d-flex justify-content-center gap-2">
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-primary"
                            onClick={(e) => {
                              stopRowClick(e);
                              openActionModal(alarm, "ack");
                            }}
                            title="Acknowledge"
                          >
                            <i className="fa-light fa-check"></i>
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger"
                            onClick={(e) => {
                              stopRowClick(e);
                              openActionModal(alarm, "clear");
                            }}
                            title="Clear Alarm"
                          >
                            <i className="fa-light fa-close"></i>
                          </button>
                        </div>
                      </td>
                      )}
                    </tr>
                    <tr className="spacer"><td colSpan={100} /></tr>
                  </>

                ))}
              </tbody>
            </table>

            {rmsActiveAlarm?.loading && <div className="text-center">Loading......</div>}

          </div>
          <p className="p-0 m-0 fs-12">Current Display 1 - {rmsActiveAlarm?.alarms?.length} Record(s), {rmsActiveAlarm?.data?.total_page} Record(s) Totally</p>

          {selectedAlarm && (
            <AcknowledgmentModel
              isModalVisible={isAckModalOpen}
              handleShowB={toggleAckModal}
              alarm={selectedAlarm}
              type={1}
              mode={actionMode}
              onSuccess={() => {
                const controller = createController();
                fetchActiveAlarms(controller.signal);
              }}
            />
          )}

          {viewAlarm && (
            <AlarmAcknowledgmentViewModal
              isOpen={isViewModalOpen}
              onClose={() => setIsViewModalOpen(false)}
              alarm={viewAlarm}
              type={1}
            />
          )}

        </div>
      </div>
    </>
  )
}